import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { NavigationEnd, Router } from '@angular/router';
import { fadeAnimation } from 'app/shared/animations/route-animations';
import { Notice, TopBlock } from 'app/shared/models/class/notice/notice';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss'],
  animations: [fadeAnimation]

})
export class HomeContentComponent extends SubscriptionBaseComponent implements OnInit, OnDestroy  {

  message = false;
  withWindow: number;
  notices: Notice[] = [];
  topNotices: TopBlock[] = [];
  notices_left: Notice[] = [];
  notices_right: Notice[] = [];
  stopBack: boolean = true;
  stopForward: boolean = true;
  notice_left_to_display: Notice;
  notice_right_to_display: Notice;
  isMobile = false;
  pausedRight = false;
  pausedLeft = false;
  speed = 0.5;

  isDetailsImageOpen = false;
  routeAnimationState = '';

  @ViewChild('scrollContainerLeft') scrollContainerLeft!: ElementRef<HTMLDivElement>;
  @ViewChild('scrollContainerRight') scrollContainerRight!: ElementRef<HTMLDivElement>;


  private animationIdRight: number | null = null;
  private animationIdLeft: number | null = null;
  private runningRight = true;
  private runningLeft = true;
  private rightScrollRemainder = 0;
  private leftScrollRemainder = 0;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly faIconService: FaiconService,
    private readonly noticeService: NoticeService,
    private readonly mediaObserver: MediaObserver,
    private readonly router: Router
  )
  {
    super();
  }

  ngOnInit(): void {
    this.routeAnimationState = this.router.url;
    this.initComponent();
    this.initSub();
  }

  ngOnDestroy(): void {
    this.stopScrollLoops();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.scheduleRestartScrollLoops();
  }

  @HostListener('window:focus')
  onWindowFocus(): void {
    this.scheduleRestartScrollLoops();
  }

  @HostListener('window:pageshow')
  onPageShow(): void {
    this.scheduleRestartScrollLoops();
  }

  @HostListener('document:visibilitychange')
  onVisibilityChange(): void {
    if (!document.hidden) {
      this.scheduleRestartScrollLoops();
    }
  }

  private stopScrollLoops(): void {
    if (this.animationIdRight !== null) {
      cancelAnimationFrame(this.animationIdRight);
      this.animationIdRight = null;
    }

    if (this.animationIdLeft !== null) {
      cancelAnimationFrame(this.animationIdLeft);
      this.animationIdLeft = null;
    }
  }

  private scheduleRestartScrollLoops(): void {
    if (this.isMobile) {
      this.stopScrollLoops();
      return;
    }

    // Laisse Angular recréer les conteneurs après changement de breakpoint avant de relancer les boucles.
    setTimeout(() => {
      this.restartScrollLoops();
    }, 0);
  }

  private restartScrollLoops(): void {
    this.stopScrollLoops();
    this.runningRight = true;
    this.runningLeft = true;
    this.pausedRight = false;
    this.pausedLeft = false;
    this.rightScrollRemainder = 0;
    this.leftScrollRemainder = 0;

    this.startLoopRight();
    this.startLoopLeft();
  }

  showMesssag(): void {
    const countBOat = +sessionStorage.getItem('countBOat') || null;
    let count: number;

    count = countBOat || 1;

    if (count < 3) {
      count++;
      sessionStorage.setItem('countBOat', count.toString());
    } else if (count === 3) {
      this.message = true;
      sessionStorage.clear();
      setTimeout(() => {
        this.message = false;
      }, 3000);
    }

  }

  seeDetailsNotice(notice: Notice): void {
    this.noticeService.detailsImage$.next({ bool: true, notice: notice });
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  pauseRight() { this.runningRight = false; this.pausedRight = true; }
  resumeRight() { this.runningRight = true; this.pausedRight = false; }

  pauseLeft() { this.runningLeft = false; this.pausedLeft = true; }
  resumeLeft() { this.runningLeft = true; this.pausedLeft = false; }

  private moveBoat(): void {
    const { width: screenWidth } = screen;
    let extremLimit;
    let marginAdd;

    if (screenWidth >= 0 && screenWidth <= 375) {
      extremLimit = 80;
      marginAdd = 10;
    } else if (screenWidth > 375 && screenWidth <= 425) {
      extremLimit = 80.5;
      marginAdd = 5;
    } else if (screenWidth > 425 && screenWidth <= 768) {
      extremLimit = 90;
      marginAdd = 5;
    } else if (screenWidth > 768 && screenWidth <= 1024) {
      extremLimit = 94;
      marginAdd = 4;
    } else if (screenWidth > 768 && screenWidth <= 2560) {
      extremLimit = 94;
      marginAdd = 4;
    }

    let contentBoat = document.getElementById('content_boat');
    const messagecontentBoat = document.getElementById('message_boat');
    const boat = document.getElementById('boat');
    let margin = 0;
    const baseLimit = 0;

    sessionStorage.setItem('courseOfBoat', '0');
    let courseOfBoat = +sessionStorage.getItem('courseOfBoat');

    margin += marginAdd;

    const intervalBoat = setInterval(() => {

      if (contentBoat) {
        contentBoat.style.marginLeft = `${margin}%`;
        if (margin > baseLimit && margin < extremLimit && contentBoat.style.transform !== 'scaleX(-1)') {
          margin += marginAdd;
        } else if (margin >= extremLimit) {
          contentBoat.style.transform = 'scaleX(-1)';
          messagecontentBoat.style.transform = 'scaleX(-1)';
          courseOfBoat++;

          margin -= marginAdd;
        } else if (margin < extremLimit && margin !== baseLimit && contentBoat.style.transform === 'scaleX(-1)') {
          margin -= marginAdd;
        } else if (margin <= baseLimit) {
          contentBoat.style.transform = '';
          contentBoat.style.transform = 'scaleX(1)';
          messagecontentBoat.style.transform = 'scaleX(1)';
          margin += marginAdd;
          courseOfBoat++;
        }

        setTimeout(() => {
          boat.style.transform = 'rotate(-20deg)';
        }, 200);

        setTimeout(() => {
          boat.style.transform = 'rotate(30deg)';
        }, 400);

        setTimeout(() => {
          boat.style.transform = 'rotate(0deg)';
        }, 600);
        if (courseOfBoat === 4) {
          clearInterval(intervalBoat);
          contentBoat.style.marginLeft = '20px';
          setInterval(() => {
            setTimeout(() => {
              boat.style.transform = 'rotate(-20deg)';
            }, 400);

            setTimeout(() => {
              boat.style.transform = 'rotate(30deg)';
            }, 600);

            setTimeout(() => {
              boat.style.transform = 'rotate(0deg)';
            }, 800);
          }, 1800);
        }
      }

    }, 1800);

  }

  goToLink(notice: Notice): void {
    window.open(`${notice.linkUrl}`, '_blank');
  }

  private startLoopRight(): void {
    const rightContainer = this.scrollContainerRight?.nativeElement;
    if (!rightContainer) return;

    let lastTime = 0;
    const step = (currentTime: number) => {
      if (!this.runningRight) {
        lastTime = currentTime;
        this.animationIdRight = requestAnimationFrame(step);
        return;
      }

      // Calculer le delta time pour un défilement fluide indépendant du framerate
      const deltaTime = lastTime ? (currentTime - lastTime) / 16.67 : 1; // Normaliser à 60fps
      lastTime = currentTime;

      // Calculer dynamiquement la hauteur d'une séquence (1/3 du total avec 3 duplications)
      const oneSequenceHeight = rightContainer.scrollHeight / 3;
      if (!oneSequenceHeight) {
        this.animationIdRight = requestAnimationFrame(step);
        return;
      }

      // Firefox peut ignorer les pas fractionnaires sur scrollTop; on accumule le reste.
      const nextIncrement = this.speed * deltaTime + this.rightScrollRemainder;
      const pixelIncrement = Math.trunc(nextIncrement);
      this.rightScrollRemainder = nextIncrement - pixelIncrement;
      if (pixelIncrement > 0) {
        rightContainer.scrollTop += pixelIncrement;
      }

      // Reset transparent : quand on a parcouru une séquence complète, revenir au début
      // Le contenu étant dupliqué 3 fois, le reset est invisible
      if (rightContainer.scrollTop >= oneSequenceHeight) {
        rightContainer.scrollTop = rightContainer.scrollTop - oneSequenceHeight;
      }

      this.animationIdRight = requestAnimationFrame(step);
    };

    cancelAnimationFrame(this.animationIdRight);
    this.animationIdRight = requestAnimationFrame(step);
  }

  private startLoopLeft(): void {
    const leftContainer = this.scrollContainerLeft?.nativeElement;
    if (!leftContainer) return;

    let lastTime = 0;
    const step = (currentTime: number) => {
      if (!this.runningLeft) {
        lastTime = currentTime;
        this.animationIdLeft = requestAnimationFrame(step);
        return;
      }

      // Calculer le delta time pour un défilement fluide indépendant du framerate
      const deltaTime = lastTime ? (currentTime - lastTime) / 16.67 : 1; // Normaliser à 60fps
      lastTime = currentTime;

      // Calculer dynamiquement la hauteur d'une séquence (1/3 du total avec 3 duplications)
      const oneSequenceHeight = leftContainer.scrollHeight / 3;
      if (!oneSequenceHeight) {
        this.animationIdLeft = requestAnimationFrame(step);
        return;
      }

      // Firefox peut ignorer les pas fractionnaires sur scrollTop; on accumule le reste.
      const nextIncrement = this.speed * deltaTime + this.leftScrollRemainder;
      const pixelIncrement = Math.trunc(nextIncrement);
      this.leftScrollRemainder = nextIncrement - pixelIncrement;
      if (pixelIncrement > 0) {
        leftContainer.scrollTop += pixelIncrement;
      }

      // Reset transparent : quand on a parcouru une séquence complète, revenir au début
      // Le contenu étant dupliqué 3 fois, le reset est invisible
      if (leftContainer.scrollTop >= oneSequenceHeight) {
        leftContainer.scrollTop = leftContainer.scrollTop - oneSequenceHeight;
      }

      this.animationIdLeft = requestAnimationFrame(step);
    };

    cancelAnimationFrame(this.animationIdLeft);
    this.animationIdLeft = requestAnimationFrame(step);
  }

  private checkThumbImageValue(notice: Notice): Notice {
    if (notice.thumbImage.startsWith(`<img src=\"<img`) && notice.thumbImage.endsWith(`>\">`)) {
      const thumbImageFilter = notice.thumbImage.replace(/^<img src=\"/, "").replace(/\">$/, "");
      notice.thumbImage = thumbImageFilter
    }
    return notice;
  }

  private initComponent(): void {
    this.withWindow = window.innerWidth;
    if (this.withWindow > 767) { this.moveBoat(); }

    this.noticeService.getNotices().subscribe({
      next: notices => {
        this.notices = notices;
        this.notices.forEach(notice => {
          if (notice.thumbImage) {
            this.checkThumbImageValue(notice);
          }
        });
        this.notices_left = this.notices.filter(n => n.blocks.includes('content_left'));
        this.notices_right = this.notices.filter(n => n.blocks.includes('content_right'));
        this.notice_left_to_display = this.notices_left[0];
        this.notice_right_to_display = this.notices_right[0];

        // Redémarrer les boucles de défilement après le rendu des notices.
        setTimeout(() => {
          this.scheduleRestartScrollLoops();
        }, 200);
      }
    });
    this.noticeService.getTopNotices().subscribe({
      next: tops => {
        this.topNotices = tops;
      }
    });
  }

  private initSub(): void {
    this.subscription.add(
      this.mediaObserver.asObservable().subscribe(() => {
        if (this.breakpointObserver.isMatched('(max-width: 600px)')) {
          this.isMobile = true;
        } else {
            this.isMobile = false;
        }

        this.scheduleRestartScrollLoops();
      })
    );

    this.subscription.add(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(event => {
          this.routeAnimationState = event.urlAfterRedirects;
          this.scheduleRestartScrollLoops();
        })
    );

  }

}
